import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { incrementSecond } from "../utils/dateTimeHelper";

const TimerDisplay = props => {
    const [currentTime, setCurrentTime] = useState('');

    useEffect(() => {
        let currentTimeForIncrement = props.time;
        setInterval(() => {
            currentTimeForIncrement = incrementSecond(currentTimeForIncrement);
            setCurrentTime(currentTimeForIncrement);
        }, 1000);
    }, [props.time]);

    return (
        <p>{currentTime}</p>
    )
}

export default TimerDisplay;
